"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _KeyboardArrowDown = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowDown"));
var _material = require("@mui/material");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _SelectorModule = _interopRequireDefault(require("../../styles/components/Selector.module.css"));
var _ArrowDropDownRounded = _interopRequireDefault(require("@mui/icons-material/ArrowDropDownRounded"));
var _constants = require("../../utils/constants");
var _Localization = require("../../Localization");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @class Select
 *
 * @param value - active value
 * @param {function} updateSelector
 * @param {function} removeSelect
 * @param item
 * @param {object} options
 * @param {boolean} removeBtn
 * @param {boolean} count
 * @param {string} theme
 * @param {string} variant
 * @param {boolean} disabled
 * @param {string} className
 * @param {string} classNameWrap
 * @param {object} style
 * @param {object} styleWrap
 * @param {string} borderBottomColor
 *
 * @return {unknown}
 *
 * @constructor
 */
const Select = _ref => {
  let {
    value,
    updateSelector,
    removeSelect,
    item,
    options,
    removeBtn = false,
    count = false,
    theme = _constants.defaultTheme,
    variant = 'primary',
    // 'secondary'
    borderBottomColor,
    disabled = false,
    className = '',
    classNameWrap = '',
    style = {},
    styleWrap = {}
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(false);
  const isPrimary = variant === 'primary';
  const MenuProps = (0, _react.useMemo)(() => ({
    PaperProps: {
      sx: {
        marginTop: '13px',
        borderRadius: isPrimary ? '8px' : 0,
        boxShadow: 'var(--main-form-shadow)',
        '.MuiList-root': {
          padding: 0,
          '.MuiMenuItem-root': {
            minHeight: 40,
            color: 'var(--main-color-cl-01)',
            display: 'block',
            lineHeight: '180%',
            borderBottom: isPrimary ? null : '1px solid var(--main-color-cl-19)',
            '&.Mui-selected': {
              background: 'inherit'
            },
            '&[aria-selected="true"]': {
              background: 'var(--main-color-cl-19)'
            },
            '&:hover': {
              background: 'var(--main-color-cl-17)'
            },
            '.count': {
              color: 'var(--main-color-cl-13)'
            },
            '.selector_remove_btn': {
              display: 'none !important'
            }
          }
        }
      }
    }
  }), [isPrimary, borderBottomColor]);
  const tv = (0, _Localization.useTranslationValue)();
  return (0, _react.useMemo)(() => {
    const {
      defaultValue = '',
      type = '',
      name = ''
    } = item;
    return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
      variant: variant === 'primary' ? 'outlined' : 'standard',
      className: classNameWrap,
      style: styleWrap
    }, /*#__PURE__*/_react.default.createElement(_material.Select, {
      disabled: disabled,
      value: value || '',
      open: open,
      onClose: () => setOpen(false),
      onChange: e => updateSelector(item, e.target.value),
      onClick: e => {
        if (e.target.closest('.MuiSelect-select')) {
          setOpen(!open);
        }
      },
      style: style,
      className: "\n                        ".concat(_SelectorModule.default.selector, " \n                        ").concat(value ? _SelectorModule.default.active : '', " \n                        ").concat(removeBtn ? _SelectorModule.default.with_remove_btn : '', " \n                        ").concat(open ? _SelectorModule.default.is_open : '', " \n                        ").concat(_SelectorModule.default[theme], "\n                        ").concat(_SelectorModule.default[variant], "\n                        ").concat(borderBottomColor ? _SelectorModule.default.customBorderBottomColor : '', "\n                        ").concat(className, "\n                    "),
      displayEmpty: true,
      IconComponent: () => variant === 'primary' ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowDown.default, {
        className: "select_arrow ".concat(open ? _SelectorModule.default.select_is_open : ''),
        onClick: () => setOpen(!open)
      }) : /*#__PURE__*/_react.default.createElement(_ArrowDropDownRounded.default, {
        className: "select_arrow ".concat(open ? _SelectorModule.default.select_is_open : ''),
        onClick: () => setOpen(!open)
      }),
      onOpen: e => {
        if (e.target.closest('button.selector_remove_btn')) {
          removeSelect({
            type,
            name
          });
        } else setOpen(true);
      },
      sx: {
        '&:after': borderBottomColor ? {
          borderBottomColor: "".concat(borderBottomColor, " !important")
        } : {}
      },
      inputProps: {
        'aria-label': 'Without label'
      },
      MenuProps: MenuProps
    }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      value: "",
      disabled: true,
      hidden: true
    }, defaultValue), options.map((opt, i) => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: i,
      value: tv(opt.value)
    }, /*#__PURE__*/_react.default.createElement("span", null, tv(opt.label)), ' ', count ? /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-1 count"
    }, opt.count ? "(".concat(opt.count, ")") : '') : null, removeBtn ? /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "btn selector_remove_btn ".concat(_SelectorModule.default.selector_remove_btn),
      onClick: () => removeSelect({
        type,
        name
      })
    }, /*#__PURE__*/_react.default.createElement(_Close.default, {
      className: 'pointer-event-none'
    })) : null))));
  }, [tv, value, item, open, setOpen, options, theme, variant, disabled, count, removeBtn]);
};
var _default = exports.default = Select;